<div class="flex h-[42px] w-full items-center justify-center lg:justify-start">
  <img class="h-[42px] w-auto max-w-full select-none object-contain"
    alt="Logo {{ theme()?.name }}"
    [src]="theme()?.assets?.logo" />
</div>
